import { trigger, transition, style, query, group, animateChild, animate, keyframes } from '@angular/animations';

export const fader =
  trigger('routeAnimations', [
    transition('* <=> fadeIn', [
      style({ opacity: 0 }),
      animate(500, style({opacity: 1}))
    ])
  ])
